// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * The state of one step of a channel-modifier sequence run (see
 * `Archive.ModifierSequenceStep`). APPEND-ONLY: the ordinal is the wire value.
 */
export enum SequenceStepStatus {
  /**
   * Not reached yet.
   */
  Pending = 0,

  /**
   * Running now: waiting for its observation, sending, or awaiting an
   * acknowledgement.
   */
  Active = 1,

  /**
   * Done: observed, sent, released, or acknowledged.
   */
  Passed = 2,

  /**
   * Its timeout, or the run's budget, ran out first.
   */
  TimedOut = 3,

  /**
   * It could not be done: a send failed, the release was not written, or the
   * acknowledgement was negative.
   */
  Failed = 4,

  /**
   * Not run: an earlier step failed and this one is not always-run, it does
   * not apply (no acknowledgement is configured), or another run sharing the
   * floor lease will run it.
   */
  Skipped = 5,
}
